<template>
	<div class="sidebar sidebar-offcanvas xk-leftnav-fixed">
		<div class="nav-menu-right">
			<div v-for="(item,lidx) in leftList" :key="lidx" v-if="item.show==1">
				<!--	<div v-for="(item,lidx) in leftList" :key="lidx" >-->
				<h6 @click="showLeftList(lidx+1)">
					{{item.classisName}}
					<i
						class="mdi mdi-chevron-right pull-right xk-i-sub"
						:class="{'nav-left-rotate':showIndex==lidx+1}"
					></i>
				</h6>
				<ul v-if="showIndex==lidx+1">
					<li v-for="(sub,index) in item.authorityList" :key="index" :class="{'active':leftIndex == sub.subPath}" v-if="sub.hasAuthority==1">
						<a href="javascript:void(0);" @click="toPage(sub.subPath)" class="nav-link xk-nav-link">{{sub.name}}</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import {get,post} from '../utils/request'
export default {
	data() {
		return {
			leftIndex: 1,
			showIndex: 1,
			bigList: [],
			leftList: []
		};
	},
	mounted() {
		
	},
	methods: {
		init() {
	 		const home = [{
				bigName: "桌面",
				leftList: [{
						classisName: "后台首页",
						authorityList: [
//						{
//								subPath: "/home.do",
//								name: "巡检人员运行桌面",
//								hasAuthority:1,
//								
//							},
							{
								subPath: "/backIndex.do",
								name: "收银通管理人员桌面",
								hasAuthority:1
							},
							{
								subPath: "/traditionIndex.do",
								name: "传统管理人员桌面",
								hasAuthority:1
							}
						],
						show:1
					},
					{
						classisName: "商户管理",
						authorityList: [{
								subPath: "/merchantManagement.do",
								name: "收银通商户管理",
								hasAuthority:1
							},
							{
								subPath: "/traditionMerchantManagement.do",
								name: "传统商户管理",
								hasAuthority:1
							},
							{
								subPath: "/traditionSalesAccount.do",
								name: "传统销户商户管理",
								hasAuthority:1
							},
							{
								subPath: "/merchantSalesManagement.do",
								name: "收银通销户商户管理",
								hasAuthority:1
							},
//							{
//								subPath: "/myMerchantManagement.do",
//								name: "我的商户",
//								hasAuthority:1
//							},
//							{
//								subPath: "/merchantToExamine.do",
//								name: "商户审核管理",
//								hasAuthority:1
//							},
							{
								subPath: "/policyConfiguration.do",
								name: "商户等级策略配置",
								hasAuthority:1
							},
							{
								subPath: "/targetMerchant.do",
								name: "目标商户管理",
								hasAuthority:1
							},
							{
								subPath: "/traditionAchievements.do",
								name: "商户绩效考核管理",
								hasAuthority:1
							}
							
						],
						show:1
					},
					{
						classisName: "设备管理",
						authorityList: [
							{
								subPath: "/equipmentTypeManagementTradition.do",
								name: "传统机设备型号管理",
								hasAuthority:1
							},
                            {
                                subPath: "/equipmentTypeManagementCashierlink.do",
                                name: "收银通设备型号管理",
                                hasAuthority:1
                            },
							{
								subPath: "/equipmentManagementTradition.do",
								name: "传统机设备管理",
								hasAuthority:1
							},
                            {
                                subPath: "/equipmentManagementCashierlink.do",
                                name: "收银通设备管理",
                                hasAuthority:1
                            },
                            {
                                subPath: "/equipmentTypeTradition.do",
                                name: "传统机设备类型",
                                hasAuthority:1
                            },
                            {
                                subPath: "/equipmentTypeCashierlink.do",
                                name: "收银通设备类型",
                                hasAuthority:1
                            },
                            {
                                subPath: "/equipmentBrand.do",
                                name: "设备品牌",
                                hasAuthority:1
                            },
//							{
//								subPath: "/myEquipmentManagement.do",
//								name: "我的设备",
//								hasAuthority:1
//							},
							{
								subPath: "/consumablesManagement.do",
								name: "耗材管理",
								hasAuthority:1
							},
							{
								subPath: "/replaceEquipmentManagmentCashierlink.do",
								name: "收银通替换设备管理",
								hasAuthority:1
							},
							{
								subPath: "/replaceEquipmentManagmentTradition.do",
								name: "传统替换设备管理",
								hasAuthority:1
							}
							
						],
						show:1
					},
					{
						classisName: "工单管理",
						authorityList: [{
								subPath: "/workOrderManagement.do",
								name: "收银通工单管理",
								hasAuthority:1
						},
						{
								subPath: "/traditionWorkOrderManagement.do",
								name: "传统工单管理",
								hasAuthority:1
						},
						
//						{
//								subPath: "/myWorkOrderManagement.do",
//								name: "我的工单",
//								hasAuthority:1
//							}
						],
						show:1
					},
					{
						classisName: "报表管理",
						authorityList: [
//						{
//								subPath: "/businessReport.do",
//								name: "商户统计报表",
//								hasAuthority:1
//							},
//							{
//								subActive: 12,
//								subPath: "",
//								subPath: "/terminalRepost.do",
//								name: "终端统计报表"
//							},
							{
								subPath: "/workOrderReport.do",
								name: "收银通工单统计报表",
								hasAuthority:1
							},
							{
								subPath: "/traditionWorkOrderReport.do",
								name: "传统工单统计报表",
								hasAuthority:1
							},
							
							{
								subPath: "/merchantLevel.do",
								name: "收银通商户等级报表",
								hasAuthority:1
							}
							,{
								subPath: "/businessTransactionRecord.do",
								name: "收银通商户交易记录报表",
								hasAuthority:1
							}
							,{
								subPath: "/accountingRecordReport.do",
								name: "收银通商户入账记录报表",
								hasAuthority:1
							},
							{
								subPath: "/handInDevice.do",
								name: "收银设备上交银行记录",
								hasAuthority:1
							},
							{
								subPath: "/traditionHandInDevice.do",
								name: "传统设备上交银行记录",
								hasAuthority:1
							}
						],
						show:1
					},
					{
						classisName: "用户管理",
						authorityList: [{
								subPath: "/userManagement.do",
								name: "角色管理",
								hasAuthority:1
							},
//							{
//								subActive: 16,
//								subPath: "",
//								subPath: "/privilegeManagement.do",
//								name: "权限管理"
//							},
							{
								subPath: "/staffManagement.do",
								name: "员工管理",
								hasAuthority:1
							}
						],
						show:1
					},
					{
						classisName: "系统管理",
						authorityList: [{
								subPath: "/suggestedManagement.do",
								name: "商户建议管理",
								hasAuthority:1
						},{
								subPath: "/messageManagement.do",
								name: "消息管理",
								hasAuthority:1
						},{
								subPath: "/logManagement.do",
								name: "日志管理",
								hasAuthority:1
						},{
								subPath: "/noticeManagement.do",
								name: "公告管理",
								hasAuthority:1
						},{
								subPath: "/securityManagement.do",
								name: "安全管理",
								hasAuthority:1
							}
						],
						show:1
					}
				]
			}];
			if(this.$route.name=='login'){
				return;
			}
			var	param={
			    type:1//获取菜单
				}
				 post('/user/authority', param).then((data)=>{
				 	var list=data.data.list,listnew=[];
				 		$.each(list, function(i) {
				 			var sublength=0;
							var authorityList=list[i].authorityList;
							$.each(authorityList, function(j) {
								if(authorityList[j].hasAuthority==1){
									list[i].show=1;
									sublength++;
								}
							});
							if(sublength==0){
								list[i].show=0;
							}
						});
	//		 	console.log(list)
			 	this.leftList=list;
				 })
			this.leftIndex = this.$route.meta.leftIndex;
			this.bigList = home; 
		//	this.leftList = home[0].leftList;
			this.showIndex= this.$route.meta.showMenu;
		},
		showLeftList(index) {
			this.showIndex = Object.is(this.showIndex, index) ? '' : index;
		},
		toPage(path) {
			this.$router.push({
				path: path
			})
		}
	}
}
</script>

<style scoped>
	.nav-menu-left {
		background: rgba(238, 238, 238, 1);
	}
	
	.nav-menu-right {
		background: rgba(255, 255, 255, 1);
	}
	.nav-menu-right li{
		float: none;
	}
	.nav-menu-right h6 {
		cursor: pointer;
		border: none;
		color: #333;
		font-weight: normal;
	}
	
	.nav-menu-right ul {
		background:#F8F8F8;
	}
	
	.xk-leftnav-fixed {
		position: fixed;
		top: 5rem;
		left: 0;
	}
	
	.xk-nav-link {
		cursor: pointer;
		color: #333;
		font-weight: 300;
	}
	
	.xk-i-sub {
		position: absolute;
		right: 0;
		line-height: 38px;
		margin-right: 20px;
	}
	
	.nav-left-rotate {
		transform: rotateZ(90deg);
		animation: rotate 0.1s linear;
	}
	
	@keyframes rotate {
		0% {
			transform: rotateZ(0deg);
		}
		100% {
			transform: rotateZ(90deg);
		}
	}
	
	.xk-big-icon {
		display: inline-block;
		width: 16px;
		height: 16px;
		margin-top: -4px;
	}
</style>


// WEBPACK FOOTER //
// src/components/leftNav.vue